// ** UI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ** Components
import Section from '@/components/common/Section';
import ImageElement from './ImageElement';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksImage as BlocksImageProps } from '@/types/graphql';

type ComponentBlocksImageProps = StrapiComponentProps<BlocksImageProps>;

const ComponentBlocksImage = ({ host, containerSx, imageSectionTitle, imageContent }: ComponentBlocksImageProps) => {
	const { id, imageTitle, imageDescription, imageItem, imageCaption } = imageContent;

	return (
		<Section containerSx={containerSx}>
			{/* 1. Standard Section Title */}
			{imageSectionTitle && (
				<Typography
					variant="title-lg"
					component="h2"
					sx={{
						mb: 6,
						color: 'common.black',
						fontSize: { xs: '2rem', md: '2.5rem' },
						lineHeight: { xs: '2.5rem', md: '3rem' },
						letterSpacing: { xs: '-0.64px', md: '-1.2px' }
					}}
				>
					{imageSectionTitle}
				</Typography>
			)}

			{/* 2. Map Video Content to V2 Design */}
			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
				<ImageElement
					key={id}
					host={host}
					imageData={imageItem}
					caption={imageCaption}
					title={imageTitle || undefined}
					description={imageDescription || undefined}
				/>
			</Box>
		</Section>
	);
};

export default ComponentBlocksImage;
